import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/**
 * App chrome for the client-centric workspace: fixed dark sidebar (w-64) on the
 * left, global topbar across the top, and the routed page in the main area.
 * Mounted as the layout route wrapping both top-level and `/client/:id/*` routes.
 */
export function ClientWorkspaceLayout() {
  return (
    <div className="min-h-screen bg-canvas">
      <Sidebar />
      <div className="pl-64">
        <Topbar />
        <main className="p-5">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
